<template>
    <div :class="serviceNameLowerCase + 'q'">
        <sag-right-side-bar-base
            :name="name"
            :serviceName="serviceName"
            @submitEvent="submitEvent"
            @displayEvent="displayEvent"
            @btnClick="emitBtnClickInit"
        >

            <template v-slot:toggle-button>
                <sag-button
                    class="mr-1"
                    v-bind="$attrs"
                    variant="info"
                    @click="btnClick"
                >
                    <b-icon-search></b-icon-search>
                </sag-button>
            </template>

            <template>
                <b-row class='align-items-end'>
                    <sag-form-text-box
                        :sagValue="formData.ProdNo"
                        id="ProdNo"
                        label="生產品號"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                    />
                    <sag-open-window
                        :serviceName="serviceName"
                        :name="'openWindow'"
                        :GridData="GridData"
                        :titles="{
                            windowTitle: '品號清單',
                            buttonName: '品號清單'
                        }"
                        @submitEvent="OpenWindow.SubmitEvent"
                    >
                    </sag-open-window>
                    
                </b-row>
                <b-row>
                    <sag-form-number
                        :sagValue="formData.Qty"
                        id="Qty"
                        label="生產數量"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                    />
                </b-row>
                <b-row>
                    <sag-form-text-box
                        :sagValue="formData.Unit"
                        id="Unit"
                        label="單位"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                    />
                </b-row>
                <b-row>
                    <sag-form-date-time-picker
                        :sagValue="formData.DeliveryDate"
                        id="DeliveryDate"
                        label="預交日期"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                    />
                </b-row>
                <b-row>
                    <sag-form-number
                        :sagValue="formData.MinOweProdQty"
                        id="MinOweProdQty"
                        label="最小分批數量"
                        @sagChangeEvent="dataChange"
                        @sagRefreshData="receiver"
                    />
                </b-row>
                
            </template>

            <!-- <template>
                <div v-if="standard">
                    <div v-for="(FormInput, index) in FormInputs" :key="index">
                        <sag-search-standard
                            :label="FormInput.FieldLabel"
                            :ConditionalType="FormInput.ConditionalType"
                            :FieldNo="FormInput.FieldName"
                            :FieldValue="FormInput.FieldValue"
                            :serviceName="serviceName"
                            @selected="changeValue($event, index)"
                            @tbValue="changeValue($event, index)"
                        >
                        </sag-search-standard>
                    </div>
                </div>
            </template> -->
            
        </sag-right-side-bar-base>
        
    </div>
</template>
<script>
import SagRightSideBarBase from '@/components/sag-right-side-bar/SagRightSideBarBase.vue'
import SagFormTextBox from '@/components/basic/SagFormTextBox.vue'
import SagFormDateTimePicker from '@/components/basic/SagFormDateTimepicker.vue'
import SagFormCheckbox from '@/components/basic/SagFormCheckbox.vue'
import SagFormTextarea from '@/components/basic/SagFormTextarea.vue'
import SagButton from '@/components/basic/SagButton.vue'
import SagSearchStandard from '@/components/sag-search/SagSearchStandard'
import SagFormNumber from '@/components/basic/SagFormNumber.vue'
import SagOpenWindow from '@/components/sag-open-window/SagOpenWindow.vue'
import { ref, reactive, computed, watch } from '@vue/composition-api'
import pageJs from './js'

import store from '@/store'
import tools from '@/sag-core/tools'
import {
    // icon
    BIconSearch,
    BRow, 
    BCol, 
} from 'bootstrap-vue'
export default {
    components: {
        SagFormTextBox,
        SagFormDateTimePicker,
        SagFormCheckbox,
        SagFormTextarea,
        SagButton,
        SagRightSideBarBase,
        SagSearchStandard,
        SagOpenWindow,
        BRow, 
        BCol,
        SagFormNumber,
        BIconSearch
    },
    props: {
        standard: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            required: true
        },
        GridData: {
            type: Object,
            default: ()=>{return {}}
        },
    },
    setup(props, context) {
        
        const serviceName = pageJs.page.pageInfo.serviceName
        const apiQueryConfig = store.state[serviceName].pageApiDatas.apiQueryConfig

        let emitBtnClick = ()=>{}
        const emitBtnClickInit = (func)=>{
            emitBtnClick = func
        }

        const serviceNameLowerCase = computed(()=>{
            return serviceName.toLowerCase()
        })

        // const FormInputs = ref([])
        const formData = reactive({
            ProdNo: '',
            Qty: 0,
            Unit: '',
            DeliveryDate: tools.getDate(),
            MinOweProdQty: 0,
        })
        const formDataInit = ()=>{
            if(formData){
                setValue('ProdNo', '')
                setValue('Qty', 0)
                setValue('Unit', '')
                setValue('DeliveryDate', tools.getDate())
                setValue('MinOweProdQty', 0)
            }
        }

        const setValue = (prop, value)=>{
            if(prop in formData){
                tools.debug.log({tag: 'test', title: '表單資料綁定', content: `{屬性名稱: ${prop}, 值: ${value}}`} )
                formData[prop] = value
            }
        }

        
        // api get standard query
        pageJs.api.apiQueryConfig().then((queryConfig)=>{
                if(Array.isArray(queryConfig)){
                    apiQueryConfig.splice(0, apiQueryConfig.length)
                    for(let i = 0; i < queryConfig.length; i++){
                        queryConfig[i].val = ''
                        apiQueryConfig.push(queryConfig[i])
                    }
                }
            })

        // listener query config, if change then change standard query
        let lock = false
        watch(apiQueryConfig, (newValue, oldValue)=>{
            if(!lock){
                lock = true
                // FormInputs.value.splice(0, FormInputs.value.length)
                // for(let i = 0; i < apiQueryConfig.length; i++){
                //     let field = apiQueryConfig[i]
                //     FormInputs.value.push(reactive({
                //         FieldLabel: field.FieldName,
                //         FieldName: field.FieldNo,
                //         ConditionalType: field.ConditionalType,
                //         FieldValue: field.val,
                //     }))
                // }
                lock = false
            }
        })

        const changeValue = (data, index)=>{
            tools.debug.log({tag: 'DEBUG', title: 'changeValue', content: ''})
            // FormInputs.value[index].FieldValue = data.FieldValue
            // FormInputs.value[index].ConditionalType = data.ConditionalType
        }

		// 確認送出事件
        const submitEvent = ()=>{
            tools.debug.log({tag: 'DEBUG', title: '開窗submit', content: ''})
            let submitData = [
                // {
                //     Keys: FormInputs.value
                // }
            ]
        }

        // 顯示狀態變更事件
        const displayEvent = (isDisplay)=>{
        }

        // 按鈕觸發
        const btnClick = ()=>{
            emitBtnClick(true)
        }

        const formRefreshDataMethod = {}
        // 重新刷新綁定資料
        const formRefreshData = ()=>{
            for(let key in formRefreshDataMethod){
                formRefreshDataMethod[key](formData[key])
            }
        }
        // 接收輸入控制項refresh method
        const receiver = (prop)=>{
            formRefreshDataMethod[prop.key] = prop.value
        }

        const OpenWindow = {
            SubmitEvent(data){
                tools.debug.log({tag: 'DEBUG', title: '開窗OK', content: ''}, data)
                setValue('ProdNo', data.MB001)
                setValue('Unit', data.MB004)
                formRefreshData()
            }
        }

        // 雙向綁定
        const dataChange = (data)=>{
            tools.debug.log({tag: 'DEBUG', title: '確認綁定data', content: ''}, data)
            setValue(data.name, data.value)
            if(data.name === 'Qty'){
                setValue('MinOweProdQty', parseInt(data.value) * 0.4)
                formRefreshData()
            }
        }


        return {
            serviceNameLowerCase,
            serviceName,
            // FormInputs,
            btnClick,
            changeValue,
            submitEvent,
            displayEvent,
            emitBtnClickInit,
            OpenWindow,
            formData,
            receiver,
            dataChange
        }
    },
}
</script>
